export enum MODALS_ENUM {
  FORGOT = "FORGOT",
  EDIT_ACCOUNT = "EDIT_ACCOUNT",
  NEW_POOL_SETTINGS = "NEW_POOL_SETTINGS",
  SHOW_PROXY_SETTING = "SHOW_PROXY_SETTING",
  DELETE_MINER = "DELETE_MINER",
  ADD_NEW_CLIENT = "ADD_NEW_CLIENT",
  CONTACT_US = "CONTACT_US",
  MORE_INFO_MODAL = "MORE_INFO_MODAL",
  MORE_CLIENT_MODAL = "MORE_CLIENT_MODAL",
  CREATE_PLAN_MODAL = "MINING_RATE_MODAL",
  QR_MODAL = "QR_MODAL",
  CONFIRM_MODAL = "CONFIRM_MODAL",
  ERROR_MODAL = "ERROR_MODAL",
  ADD_NEW_NOTIFS_EMAIL = "ADD_NEW_NOTIFS_EMAIL",
  CREATE_TWO_FA_MODAL = "CREATE_TWO_FA_MODAL",
  USE_TWO_FA_MODAL = "USE_TWO_FA_MODAL",
  ADD_LOCAION = "ADD_LOCAION",
  ADD_LOCAION_MOBX = "ADD_LOCAION_MOBX",
  LOGS_MODAL = "LOGS_MODAL",
  EDIT_CLIENT_COLOR = "EDIT_CLIENT_COLOR",
  RACK_MODAL = "RACK_MODAL",
  RACK_MODAL_MOBX = "RACK_MODAL_MOBX",
  EQUIPMENT_MODAL = "EQUIPMENT_MODAL",
  ADD_BUILDING_MOBX = "ADD_BUILDING_MOBX",
  ADD_MINERS_TABLE_TAB = "ADD_MINERS_TABLE_TAB",
  UPLOAD_MINER_PHOTO_MODAL = "UPLOAD_MINER_PHOTO_MODAL",
  CONFIRM_MINERS_CHANGES_MODAL = "CONFIRM_MINERS_CHANGES_MODAL",
  CONFIRM_MINERS_ONOFF_MODAL = "CONFIRM_MINERS_ONOFF_MODAL",
  CHANGE_CLIENT_PASSWORD_MODAL = "CHANGE_CLIENT_PASSWORD_MODAL",
  CREATE_CONTRACT_MODAL = "CREATE_CONTRACT_MODAL",
  MINERS_DELETE_ERROR_MODAL = "MINERS_DELETE_ERROR_MODAL",
  MINERS_PROFILE_CREATE_MODAL = "MINERS_PROFILE_CREATE_MODAL",
  MINERS_PROFILE_CREATE_MOBX_MODAL = "MINERS_PROFILE_CREATE_MOBX_MODAL",
  ADD_SPAREPARTS = "ADD_SPAREPARTS",
  ADD_SPAREPARTS_TYPES = "ADD_SPAREPARTS_TYPES",
  MOVE_PART_MODAL = "MOVE_PART_MODAL",
  CREATE_SPARE_PART_MODAL = "CREATE_SPARE_PART_MODAL",
  CHOICE_MODAL = "CHOICE_MODAL",
  MINER_STATUSES_MODAL = "MINER_STATUSES_MODAL",
  MINERS_PORTS = "MINERS_PORTS",
  EDIT_TEMPLATE = "EDIT_TEMPLATE",
  MOVE_MINERS_MODAL = "MOVE_MINERS_MODAL",
  EDIT_GENERAL_NOTIFICATIONS = "EDIT_GENERAL_NOTIFICATIONS",
  EDIT_NOTIFICATION_GROUP = "EDIT_NOTIFICATION_GROUP",
  EDIT_NOTIFICATION_MINER = "EDIT_NOTIFICATION_MINER",
  ASSIGN_NOTIFICATION_GROUP = "ASSIGN_NOTIFICATION_GROUP",
}
